import styled, { css } from "styled-components"
import { BaseCard } from "../base-card/base-card.styles"
import { space } from "styled-system"

const inputStateStyling = ({ theme: { colors, versionA }, statusStyle }) => {
  if (!versionA) return colors.white
  if (statusStyle === "default") return colors.midGrey
  if (statusStyle === "success") return colors.successGreen
  if (statusStyle === "error") return colors.errorRed
}

const VersionBStyle = css`
  background-color: ${({ theme: { colors } }) => colors.accentBlue};
  color: ${({ theme: { colors } }) => colors.white};
`
const VersionAStyle = css`
  background-color: ${({ theme: { colors } }) => colors.white};
  color: ${({ theme: { colors } }) => colors.black};
`
const ContainerBgStyling = ({ theme: { versionA } }) => {
  if (versionA) return VersionAStyle
  else return VersionBStyle
}

// hacky way to get the emailCTA wider than blog post content:
export const WiderContainer = styled.div`
  ${space}
  @media only screen and (min-width: 1251px) {
    position: relative;
    width: 134%;
    margin-left: -17%;
    margin-right: -17%;
  }

  @media only screen and (max-width: 760px) {
    position: relative;
    width: 106%;
    margin-left: -3%;
    margin-right: -3%;
  }

  @media only screen and (max-width: 480px) {
    position: relative;
    width: 113%;
    margin-left: -6.5%;
    margin-right: -6.5%;
  }
`
export const ArticleCTAContainer = styled(BaseCard)`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  padding: 60px;
  border-radius: 25px;

  ${ContainerBgStyling}
  .content-container > h4 {
    margin: 0 0 15px;
    color: inherit;
  }
  @media only screen and (max-width: 760px) {
    padding: 30px 20px;
    .content-container > h4 {
      margin-bottom: 10px;
    }
  }
`
export const ContentContainer = styled.div`
  grid-column: 1/8;
  div > p {
    margin: 0 0 50px;
    ${({ theme: { typography } }) => typography.desktop.body};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
    color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.darkGrey : colors.white};
  }

  p {
    margin: 10px 0 0;
  }
  @media only screen and (max-width: 1250px) {
    grid-column: 1/-1;
  }

  @media only screen and (max-width: 760px) {
    div > p {
      margin-bottom: 25px;
      ${({ theme: { typography } }) => typography.mobile.body};
      font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
    }
  }
`

export const EmailSubscribeHorizontalSubTitle = styled.p`
  ${({ theme: { typography } }) => typography.desktop.metadata};
  color: ${({ theme: { colors, versionA } }) =>
    versionA ? colors.grey : colors.white};
  @media only screen and (max-width: 760px) {
    font-size: 13px;
    line-height: 18px;
  }
`

export const EmailSubscribeHorizontalFormContainer = styled.div`
  display: flex;
  position: relative;
  width: 95%;

  button {
    height: 46px;
    background-color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.accentPink : colors.white};
    color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.white : colors.accentBlue} !important;
    border-color: transparent;
    margin: 0;
    margin-left: 10px;
    font-size: 15px;
  }
  button:hover {
    background-color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.accentPinkDarkened : colors.accentSkyBlue};
    border-color: transparent;
  }

  button:focus-visible {
    box-shadow: ${({ theme: { versionA } }) =>
      versionA ? "0 0 0 2px #f51767" : "0 0 0 2px #fff"};
    border-color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.white : colors.accentBlue};
  }

  @media only screen and (max-width: 870px) {
    display: block;
    width: 100%;
    button {
      width: 100%;
      margin: 10px 0;
    }
  }
`

export const EmailSubscribeStatus = styled.h5`
  position: relative;
  top: -10px;
  ${({ theme: { typography } }) => typography.desktop.metadata};
  color: ${inputStateStyling};
  font-weight: bold;
  margin: 0;

  @media only screen and (max-width: 760px) {
    top: 0;
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 18px;
  }
`

export const EmailSubscribeHorizontalInput = styled.input`
  position: relative;
  padding: 10px 20px;
  height: 46px;
  width: 100%;
  border-radius: 999px; /* make sure element is fully rounded  */
  border: 1px solid ${inputStateStyling};
  color: ${({ theme: { colors, versionA } }) =>
    versionA ? colors.grey : colors.white};
  background-color: ${({ theme: { colors, versionA } }) =>
    versionA ? colors.white : colors.accentBlue};
  font-size: 16px;
  ::placeholder {
    color: ${({ theme: { colors, versionA } }) =>
      versionA ? colors.grey : colors.white};
  }
`

export const StatusIcon = styled.div`
  position: absolute;
  right: 175px;
  top: 10px;
  svg > circle {
    stroke: #fff;
  }
  @media only screen and (max-width: 870px) {
    right: 10px;
    top: 9px;
  }
`
